export const MediaDataGifts = [
  {
    img: "/Images/Gifts/elephant.png",
    label: 'Ajude-nos a comprar um elefante pink. É útil? Não! Mas é rosa!',
    value: 'R$ 95,00'
  },
  {
    img: "/Images/Gifts/esferas.png",
    label: 'Já ouviu falar das Esferas do Dragão? #GokuPira e Wellington também...',
    value: 'R$150,00'
  },
  {
    img: "/Images/Gifts/fox.png",
    label: "What does the fox say? Não entendeu? Procura no youtube! hahaha",
    value: 'R$ 70,00'
  },
  {
    img: "/Images/Gifts/fusca.png",
    label: 'Somos contra a violência gratuita, então não é um fusca azul...',
    value: 'R$ 240,00'
  },
  {
    img: "/Images/Gifts/giraffe.png",
    label: 'É uma autêntica e rara girafa africana, com trajes típicos!',
    value: "R$ 190,00"
  },
  {
    img: "/Images/Gifts/masterSword.png",
    label: 'Certeza que o Wellington ficaria bem feliz com isso!',
    value: 'R$ 310,00'
  },
  {
    img: "/Images/Gifts/thor.png",
    label: 'Chupa, Capitão América! Também somos dignos do mjolnir',
    value: "R$ 57,00"
  },
  {
    img: "/Images/Gifts/throne.png",
    label: 'Quando você joga o jogo dos tronos, você vence ou você morre...',
    value: 'R$138,00'
  },
  {
    img: "/Images/Gifts/unicorn.png",
    label: 'É um fucking unircórnio!',
    value: 'R$129,00'
  },
];
